module.exports = __webpack_public_path__ + "img/monitor.28089c88.svg";